import React from 'react';
import { NOTE_COPY as C } from '../../utils/figmaLinkCopy';
import './FigmaLinkNote.css';

// The line under a Figma link field. One of:
//   converted    quiet: we changed a design link into a prototype link
//   checking     spinner
//   viewable     green: anyone can open it
//   not_viewable red box with the fix
//   not_figma    amber: not a Figma link at all
//   unsupported  amber: a Figma link, but not a prototype (FigJam, Make, slides)
// 'unknown' (the check could not run) is never shown: a broken check must not cry wolf.

const Icon = ({ name }) => {
  const paths = {
    info: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 8h.01" />
      </>
    ),
    alert: (
      <>
        <path d="M12 3.5l9.5 16.5h-19z" />
        <path d="M12 10v4.5M12 17.5h.01" />
      </>
    ),
    check: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M8 12.5l3 3 5-6" />
      </>
    ),
    link: (
      <>
        <path d="M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1" />
        <path d="M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1" />
      </>
    ),
  };
  return (
    <svg className="fln-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {paths[name]}
    </svg>
  );
};

export default function FigmaLinkNote({ kind, onShowHow, onRecheck }) {
  if (kind === 'converted') {
    return (
      <div className="fln fln-quiet" role="status">
        <Icon name="link" />
        <span>{C.converted}</span>
      </div>
    );
  }
  if (kind === 'checking') {
    return (
      <div className="fln fln-pending" role="status">
        <span className="fln-spinner" aria-hidden="true" />
        <span>{C.checking}</span>
      </div>
    );
  }
  if (kind === 'viewable') {
    return (
      <div className="fln fln-ok" role="status">
        <Icon name="check" />
        <span>{C.viewable}</span>
      </div>
    );
  }
  if (kind === 'not_viewable') {
    return (
      <div className="fln-box fln-box-red" role="alert">
        <Icon name="alert" />
        <div>
          <div className="fln-head">{C.notViewable.head}</div>
          <div>{C.notViewable.body}</div>
          <div className="fln-actions">
            <button type="button" className="fln-btn-primary" onClick={onShowHow}>{C.notViewable.show}</button>
            <button type="button" className="fln-btn-text" onClick={onRecheck}>{C.notViewable.again}</button>
          </div>
        </div>
      </div>
    );
  }
  if (kind === 'not_figma') {
    return (
      <div className="fln-box fln-box-amber" role="alert">
        <Icon name="info" />
        <div>
          <div className="fln-head">{C.notFigma.head}</div>
          <div>{C.notFigma.body}</div>
        </div>
      </div>
    );
  }
  if (kind === 'unsupported') {
    return (
      <div className="fln-box fln-box-amber" role="alert">
        <Icon name="info" />
        <div>
          <div className="fln-head">{C.unsupported.head}</div>
          <div>{C.unsupported.body}</div>
        </div>
      </div>
    );
  }
  return null;
}
